<template>
  <div class="analytics-tab__title-row d-flex justify-content-between flex-wrap">
    <SectionTitle
      :text="`Структура первичного энергопотребления по видам топлива, ЭДж${
        byFuelSummary.length ? ` (${byFuelSummary[0].year} г.)` : ''
      }`"
    />
    <p class="hint">Источник: BP</p>
  </div>
  <template v-if="byFuelSummary.length">
    <EChartsHorizontalBar
      :showLegend="false"
      :valueFractionDigits="2"
      :barMaxWidth="20"
      :labels="byFuelSummary.map((x) => x.title + ', ЭДж')"
      :dataset="[
        {
          data: byFuelSummary.map((x) => Number(x.value.toFixed(2))),
          colors: ['#309CFF', '#3C8CD7', '#177ada', '#0264BE', '#004687', '#002D56'],
        },
      ]"
    />
  </template>
  <template v-else><div>Нет данных.</div></template>
  <div>
    <SectionTitle text="Выбросы СО2, млн.т (2021 г.)" />
    <EChartsVerticalBar
      :key="chartUpdater"
      :labels="co2ChartLabels"
      :dataset="co2ChartDataset"
      :height="400"
      :legendSelectable="false"
      :valueFractionDigits="0"
    />
  </div>
</template>

<script>
  import SectionTitle from '@/common/components/redesigned/SectionTitle/SectionTitle.vue';

  import EChartsHorizontalBar from '@/components/ChartComponents/apacheEcharts/EChartsHorizontalBar.vue';
  import EChartsVerticalBar from '@/components/ChartComponents/apacheEcharts/EChartsVerticalBar.vue';

  import Api from '../api';
  export default {
    name: 'GreenEconomy',
    components: {
      EChartsHorizontalBar,
      EChartsVerticalBar,
      SectionTitle,
    },
    props: {
      countryId: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        byFuelSummary: [],
        co2Summary: [],
        chartUpdater: 1,
      };
    },
    mounted() {
      this.loadSummary();
    },
    methods: {
      loadSummary() {
        this.byFuelSummary = [];
        this.co2Summary = [];
        Api.getGreenEconomyByFuelSummry(this.countryId).then((response) => {
          this.byFuelSummary = response.data.sort((a, b) => a.value - b.value);
        });
        Api.getGreenEconomyCo2Summry(this.countryId).then((response) => {
          this.co2Summary = response.data;
        });
      },
    },
    computed: {
      co2ChartLabels() {
        return this.co2Summary.map((x) => x.title);
      },
      co2ChartDataset() {
        return [
          {
            label: '',
            data: this.co2Summary.map((x) => Number(x.value.toFixed(0))),
            color: '#2F84EB',
          },
        ];
      },
    },
    watch: {
      countryId: function () {
        this.loadSummary();
      },
    },
  };
</script>

<style scoped lang="scss">
  .hint {
    font-size: 12px;
    color: #787f8f;
  }
</style>
